export default function googleAnalyticsTracking(type = 'page', settings = {}) {
  const pathname = settings.path || window.location.pathname + window.location.search;
  const additionalSettings = {nonInteraction: !!settings.nonInteraction };

  if (window.ga) {
    if (type === 'page') {
      window.ga('set', 'page', pathname);
      window.ga('send', 'pageview', additionalSettings);
    } else if (type === 'event') {
      if (!settings.category || !settings.label) {
        throw new Error('Required settings not provided');
      }

      window.ga('send', 'event', settings.category, (settings.action || 'click'), settings.label, additionalSettings);
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/googleAnalyticsTracking.js